import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";
import { MaintenanceWorkflowForwardingCancelSchemaValidationSchema } from "../../Show/schema/forwardings/cancelMaintenanceWorflowForwarding.schema";

interface UseCancelMaintenanceWorkflowForwadingProps {
  id?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useCancelMaintenanceWorkflowForwading = ({ id, onSuccess, onError }: UseCancelMaintenanceWorkflowForwadingProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation<void, AxiosError, MaintenanceWorkflowForwardingCancelSchemaValidationSchema>({
    mutationKey: ['cancelMaintenanceWorkflowForwading', id],
    mutationFn: async (data) => privateAxios.put(`/maintenance/forwardings/${id}/cancel`, {
      cancel_reason: data.cancel_reason
    }),
    onSuccess,
    onError,
  });
};

export default useCancelMaintenanceWorkflowForwading;